'use strict';

// Specified state transitions per particular actions.
export default {};
